import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ebbdc03a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "consultations" }
const _hoisted_2 = {
  key: 0,
  class: "h-100 w-100 d-flex flex-column align-items-center justify-content-center text-center"
}
const _hoisted_3 = { class: "h5 title fw-bold text-primary" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add me-12",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "scroll-component-container"
}
const _hoisted_6 = { class: "scroll-component" }
const _hoisted_7 = { class: "d-flex justify-content-between" }
const _hoisted_8 = { class: "date text-dark fw-bold" }
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 1,
  class: "icon icon-user-circle me-8",
  title: "En persona"
}
const _hoisted_11 = {
  key: 0,
  class: "text-primary fw-bold"
}
const _hoisted_12 = { class: "text-tertiary fw-bold" }
const _hoisted_13 = { class: "d-flex justify-content-between" }
const _hoisted_14 = { class: "title" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-expand-right text-sm align-self-center ms-4",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-expand-right text-sm align-self-center ms-4",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_professional_consultation_create = _resolveComponent("the-professional-consultation-create")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.consultations.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('No hay consultas')), 1),
          (_ctx.can('professional.expedient.consultation.store') && _ctx.allowCreate)
            ? (_openBlock(), _createBlock(_component_v_button, {
                key: 0,
                variant: "secondary",
                class: "new-consultation mt-48",
                "aria-label": this.$t('Nueva consulta'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalToShow = 'the-professional-consultation-create'))
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('Nueva consulta')), 1)
                ]),
                _: 1
              }, 8, ["aria-label"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consultations, (consultation, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "card item py-12 px-16 mb-8",
                key: index
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$str.formatDateTime(consultation.initDate)), 1),
                  _createElementVNode("div", null, [
                    (consultation.via === 'phone' || consultation.via === 'videocall')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "icon icon-phone me-8",
                          title: consultation.via === 'phone' ? 'Teléfono' : 'Videollamada'
                        }, null, 8, _hoisted_9))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('Consulta')), 1)
                  ])
                ]),
                (!!_ctx.showPatient && !!consultation.expedientData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(consultation.expedientData.patient.user.name) + " " + _toDisplayString(consultation.expedientData.patient.user.surname), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, _toDisplayString(!!consultation.clinic ? consultation.clinic.name : _ctx.$t('- Sin clínica asociada -')), 1),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.type(consultation)), 1),
                  (_ctx.can('professional.expedient.show') && !_ctx.goShowConsultation)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: {name: 'professional.expedient.show',
                params: {
                  expedient:  consultation.expedientId, tabName: 'general'},
                  query: { tratamiento: _ctx.currentTreatment?.id}},
                        class: "btn btn-icon btn-sm text-primary p-0 justify-content-center",
                        "aria-label": this.$t('Ver paciente')
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Ver paciente')) + " ", 1),
                          _hoisted_15
                        ]),
                        _: 2
                      }, 1032, ["to", "aria-label"]))
                    : _createCommentVNode("", true),
                  (_ctx.can('professional.expedient.show') && !!_ctx.goShowConsultation)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: {name: 'professional.expedient.show',
                  params: {
                    expedient:  consultation.expedientId,
                    tabName: 'consultas',
                    treatment: _ctx.$route.params.treatment,
                    consultation: _ctx.$route.params.consultation,
                    },
                    query: {
                    tratamiento: _ctx.currentTreatment?.id,
                    }},
                        class: "btn btn-icon btn-sm text-primary p-0 justify-content-center",
                        "aria-label": this.$t('Ver consulta'),
                        onClick: ($event: any) => (_ctx.setConsultation(consultation))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Ver consulta')) + " ", 1),
                          _hoisted_16
                        ]),
                        _: 2
                      }, 1032, ["to", "aria-label", "onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ])),
    (_ctx.modalToShow === 'the-professional-consultation-create')
      ? (_openBlock(), _createBlock(_component_the_professional_consultation_create, {
          key: 2,
          onClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalToShow = null))
        }))
      : _createCommentVNode("", true)
  ]))
}